import React, { useState, useEffect } from 'react';
import { ContentfulCollapsiblePanelSection, Maybe } from 'src/graphql-types';
import { PrivateCollapsiblePanelSection } from 'src/utils/common';
import { CollapsiblePanelTemplate } from './collapsiblePanelTemplate';
import { LoginForMore } from 'src/components/loginComponents/loginForMore';
import { useLoginManager } from 'src/utils/login-manager';

interface Props {
	panelsCollection?: Maybe<ContentfulCollapsiblePanelSection | PrivateCollapsiblePanelSection>[];
	parentId?: string;
}

export const CollapsiblePanelCollection = (props: Props) => {
	const loginManager = useLoginManager();
	const [showLoginBanner, setShowLoginBanner] = useState(false);
	const { panelsCollection, parentId } = props;

	useEffect(() => {
		if (panelsCollection && (panelsCollection.length || 0) > 0) {
			setShowLoginBanner(
				panelsCollection.some((panel) =>
					Boolean((panel as Maybe<PrivateCollapsiblePanelSection>)?.contentType)
				) && !loginManager.isLoggedIn
			);
		}
	}, [loginManager.isLoggedIn]);

	if (panelsCollection && (panelsCollection.length || 0) > 0) {
		return (
			<>
				{showLoginBanner && <LoginForMore />}
				{panelsCollection
					.filter((panel) => panel)
					.map((panel) => {
						return (
							<CollapsiblePanelTemplate
								key={panel?.contentful_id || ''}
								parentId={parentId}
								data={panel as ContentfulCollapsiblePanelSection | PrivateCollapsiblePanelSection}
							/>
						);
					})}
			</>
		);
	}

	return <div></div>;
};
